import { useContext, useLayoutEffect, useMemo, useState } from "react";
import useAuth from "../../../../../../Hooks/useAuth";
import CustomizerContext from "../../../../../../_helper/Customizer";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import { TechnicalLinkTypes } from "../types";
import { toast } from "react-toastify";
import { formatDateWithTimeZone } from "../../../../../../_helper/dateHelper";
import { CustomerApi, CustomerBranchApi, InfrastructureApi, LinkApi, LinkStatusApi, LinkTypeApi, LocationDropdownApi, LocationTypeApi, OrgZoneApi, ProductApi, ProductClassApi, ProductGroupApi, ProductTypeApi, RegionApi } from "../../../../../../api";
import {
  Name,
  DateCreated,
  DateModified,
  Infrastructures,
  Comment,
  CustomerBranch,
  Customer,
  Zone,
  Region,
  LocationType,
  Location,
  LinkType,
  LinkStatuses,
  ProductGroup,
  ProductClass,
  ProductType,
  Product,
  ProductInfo,
  PoPInfo,
  Pop,
  Infrastructure,
  LinkStatus,
} from "../../../../../../Constant";
import { ContactTypeVal, createDropdownField } from "../../../../../../Data/FormField/PublicData";
import { ContactRow } from "./TechnicalLinkList";


export default function useTechnicalLinkList() {
  const axiosPrivate = useAxiosPrivate();
  const title = Infrastructures;
  const { userOrganisationId }: any = useAuth();
  const orgZoneApi = OrgZoneApi(userOrganisationId);
  const regionApi = RegionApi(userOrganisationId);

  const [data, setData] = useState<TechnicalLinkTypes[]>([]);

  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(25);

  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState<any>({});
  const [isNewFieldAdded, setIsNewFieldAdded] = useState(false);
  const [filterformFields, setFilterFormFields] = useState<any[]>([]);
  const [isNewFilterFieldAdded, setIsNewFilterFieldAdded] = useState(false);

  const toggleFilterVisibility = () => {
    setShowFilter(!showFilter);
  };

  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "remark",
      name: "remark",
      label: Comment,
      type: "textarea",
      value: "",
      required: true,
      colSize: 6,
    }
  ]);

  const customerDropdownField = {
    name: "contact_id",
    id: "contact_number, company_name, last_name, first_name",
    api: `${CustomerApi}`,
    label: `${Customer}`,
    type: "input-select",
    value: { id: "", label: "" },
    colSize: 6,
    required: true,
    disabled: true,
    onSelectedChange : async function (selectedId: number, updatedFields: any) { 
      const cBField = updatedFields.find((field:any) => field.id === 'contact_branch_id');
      
      if (cBField) {
        const endPoint = `${CustomerBranchApi}?organisation_id=${userOrganisationId}&contact_id=${selectedId}`
        await cBField.fetchOptions(selectedId, false, endPoint);
        setFormFields([...updatedFields]);
      } 
    }
  };

  const customerBranchDropdownField = createDropdownField(
      axiosPrivate,
      "contact_branch_id",
      "contact_branch_id",
      CustomerBranch,
      "",
      "",
      6, false
  );

  const ZoneOrgDropdownField = createDropdownField(axiosPrivate,
    'zone_id',
    'zone_id',
    `${Zone}`,
    `${orgZoneApi}`,
    '',
    6
  );

  const RegionOrgDropdownField = createDropdownField(axiosPrivate,
    'region_id',
    'region_id',
    `${Region}`,
    ``,
    '',
    6
  );

  const LocationTypeDropdownField = createDropdownField(axiosPrivate,
    'location_type_id',
    'location_type_id',
    `${LocationType}`,
    ``,
    '',
    6
  );

  const LocationDropdownField = createDropdownField(axiosPrivate,
    'location_id',
    'location_id',
    `${Location}`,
    ``,
    '',
    6
  );

  ZoneOrgDropdownField.onChange = async (selectedZoneId, updatedFields) => { 
    const regionField = updatedFields.find((field: any) => field.id === 'region_id');
    
    if (regionField) {
      const endPoint = `${regionApi}?zone_id=${selectedZoneId}`
      await regionField.fetchOptions(selectedZoneId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  RegionOrgDropdownField.onChange = async (selectedRegionId, updatedFields) => { 
    const modelField = updatedFields.find((field: any) => field.id === 'location_type_id');
    
    if (modelField) {
      const endPoint = `${LocationTypeApi}?organisation_id=${userOrganisationId}`
      await modelField.fetchOptions(selectedRegionId, false, endPoint);
      setFormFields([...updatedFields]);
    }
  };

  LocationTypeDropdownField.onChange = async (selectedId, updatedFields) => { 
    const modelField = updatedFields.find((field: any) => field.id === 'location_id');
    
    if (modelField) {
      //region_id=${selectedRegionId}
      const endPoint = `${LocationDropdownApi(userOrganisationId)}?location_type_id=${selectedId}`
      await modelField.fetchOptions(selectedId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  const LinkTypeDropDown = createDropdownField(
      axiosPrivate,
      "link_type_id",
      "link_type_id",
      LinkType,
      `${LinkTypeApi}?organisation_id=${userOrganisationId}`,
      "",
      6
  );

  const LinkStatusDropDown = createDropdownField(
      axiosPrivate,
      "link_status_id",
      "link_status_id",
      LinkStatuses,
      `${LinkStatusApi}?organisation_id=${userOrganisationId}`,
      "",
      6
  );

  const InfrastructureDropDown = createDropdownField(
      axiosPrivate,
      "infrastructure_id",
      "infrastructure_id",
      Infrastructures,
      `${InfrastructureApi}?organisation_id=${userOrganisationId}`,
      "",
      6
  );

  const ProductGroupDropDown = createDropdownField(
    axiosPrivate,
    "product_group_id",
    "product_group_id",
    ProductGroup,
    `${ProductGroupApi}?organisation_id=${userOrganisationId}`,
    "",
    6
  );
  
  const ProductClassDropDown = createDropdownField(
    axiosPrivate,
    "product_class_id",
    "product_class_id",
    ProductClass,
    "",
    "",
    6
  );

  const ProductTypeDropDown = createDropdownField(
      axiosPrivate,
      "product_type_id",
      "product_type_id",
      ProductType,
      "",
      "",
      6
  );

  const ProductDropDown = createDropdownField(
      axiosPrivate,
      "product_id",
      "product_id",
      Product,
      "",
      "",
      6
  );

  ProductGroupDropDown.onChange = async (selectedId, updatedFields) => { 
    const targetField = updatedFields.find((field: any) => field.id === 'product_class_id');
    
    if (targetField) {
      const endPoint = `${ProductClassApi}?organisation_id=${userOrganisationId}&product_group_id=${selectedId}`
      await targetField.fetchOptions(selectedId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  ProductClassDropDown.onChange = async (selectedId, updatedFields) => { 
    const targetField = updatedFields.find((field: any) => field.id === 'product_type_id');
    
    if (targetField) {
      const endPoint = `${ProductTypeApi}?organisation_id=${userOrganisationId}&product_class_id=${selectedId}`
      await targetField.fetchOptions(selectedId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  ProductTypeDropDown.onChange = async (selectedId, updatedFields) => { 
    const targetField = updatedFields.find((field: any) => field.id === 'product_id');
    
    if (targetField) {
      const endPoint = `${ProductApi}?organisation_id=${userOrganisationId}&product_type_id=${selectedId}`
      await targetField.fetchOptions(selectedId, false, endPoint);
      setFormFields([...updatedFields]);
    } 
  };

  // ?? Call on every dependent change
  useLayoutEffect(() => {

    const updateFields = async () => {
      try {
        if (!isNewFieldAdded) {
          const updatedFields = [
            customerDropdownField,
            customerBranchDropdownField,
            LinkTypeDropDown, 
            InfrastructureDropDown, 
            LinkStatusDropDown,
            {
              type: 'group-title',
              label: `${PoPInfo}`,
            },
            ZoneOrgDropdownField,
            RegionOrgDropdownField, 
            LocationTypeDropdownField,
            LocationDropdownField,
            {
              type: 'group-title',
              label: `${ProductInfo}`,
            },
            ProductGroupDropDown,
            ProductClassDropDown,
            ProductTypeDropDown,
            ProductDropDown, 
              
            ...formFields
          ];
          await LinkTypeDropDown.fetchOptions();
          await InfrastructureDropDown.fetchOptions();
          await LinkStatusDropDown.fetchOptions();
          await ZoneOrgDropdownField.fetchOptions();
          await ProductGroupDropDown.fetchOptions();
          setFormFields(updatedFields);  
          setIsNewFieldAdded(true);

        }
      } catch (error) {
        //console.error('Error fetching options:', error);
      }
    };

    updateFields();

  }, [formFields, isNewFieldAdded, LinkTypeDropDown, InfrastructureDropDown, ProductGroupDropDown, ZoneOrgDropdownField, LinkStatusDropDown, customerDropdownField]);

  
  //=================== FILTER =================== //
  const customerDropdownFieldFilter = {
    name: "contact_id",
    id: "contact_number, company_name, last_name, first_name",
    api: `${CustomerApi}`,
    label: `${Customer}`,
    type: "input-select",
    value: { id: "", label: "" },
    colSize: 6,
    required: false,
    disabled: false,
    onSelectedChange : async function (selectedId: number, updatedFields: any) { 
      const cBField = updatedFields.find((field:any) => field.id === 'contact_branch_id');
      
      if (cBField) {
        const endPoint = `${CustomerBranchApi}?organisation_id=${userOrganisationId}&contact_id=${selectedId}`
        await cBField.fetchOptions(selectedId, false, endPoint);
        setFilterFormFields([...updatedFields]);
      } 
    }
  };

  const LocationDropdownFieldFilter = createDropdownField(axiosPrivate,
    'location_id',
    'location_id',
    `${Location}`,
    `${LocationDropdownApi(userOrganisationId)}`,
    '',
    6, false
  );

  useLayoutEffect(() => {

    const fetchFilterData = async () => {
      try {
        if (!isNewFilterFieldAdded) { 
          const NewLinkTypeDropDown = { ...LinkTypeDropDown };
          NewLinkTypeDropDown.setRequiredStatus(false);
          NewLinkTypeDropDown.setDisabledStatus(false);

          const NewLinkStatusDropDown = { ...LinkStatusDropDown };
          NewLinkStatusDropDown.setRequiredStatus(false);
          NewLinkStatusDropDown.setDisabledStatus(false);

          const NewInfrastructureDropDown = { ...InfrastructureDropDown };
          NewInfrastructureDropDown.setRequiredStatus(false);
          NewInfrastructureDropDown.setDisabledStatus(false);

          const updatedFields = [
            customerDropdownFieldFilter, 
            NewLinkTypeDropDown, 
            NewLinkStatusDropDown,
            NewInfrastructureDropDown,
            LocationDropdownFieldFilter,
            //dynamic_field('track_number', `${TrackingNumber}`, 'text', 6, false),
            //dynamic_field('source_system_user_id', `${SourceSystemUser}`, 'text', 6, false),
            ...filterformFields
          ];
        
          await Promise.all([
            //updatedFields[0].fetchOptions(),
            NewLinkTypeDropDown.fetchOptions(),
            NewLinkStatusDropDown.fetchOptions(),
            NewInfrastructureDropDown.fetchOptions(),
            LocationDropdownFieldFilter.fetchOptions(),
          ]);
          
          setFilterFormFields(updatedFields);
          setIsNewFilterFieldAdded(true);
        }
      } catch (error) {
        //console.error('Error fetching options:', error);
      }

    };

    fetchFilterData();
  }, [filterformFields, isNewFilterFieldAdded]);

  const tableColumns = [
    {
      name: Name,
      selector: (row: (typeof data)[0]) => `${row.contact.last_name}`,
      sortable: true,
      center: false,
      cell: (row: (typeof data)[0]) => ContactRow(row),
    },
    {
      name: Product,
      selector: (row: (typeof data)[0]) => `${row.product?.name ?? ''}`,
      sortable: true,
      center: false,
    },
    {
      name: LinkType,
      selector: (row: (typeof data)[0]) => `${row.link_technical_detail?.link_type.name}`,
      sortable: true,
      center: false,
    },
    {
      name: Pop,
      selector: (row: (typeof data)[0]) => `${row.link_technical_detail?.location.name}`,
      sortable: true,
      center: false,
    },
    {
      name: Infrastructure,
      selector: (row: (typeof data)[0]) => `${row.link_technical_detail?.infrastructure?.name ?? ''}`,
      sortable: true,
      center: false,
    },
    /* {
      name: Status,
      selector: (row: (typeof data)[0]) => `${row.is_active}`,
      sortable: true,
      center: true,
      cell: (row: (typeof data)[0]) => StatusRow(row),
    }, */
    {
      name: Comment,
      selector: (row: (typeof data)[0]) => `${row.remark ?? ''}`,
      sortable: true,
      center: false,
    },
    {
      name: LinkStatus,
      selector: (row: (typeof data)[0]) => `${row.link_technical_detail?.link_status?.name ?? ''}`,
      sortable: true,
      center: false,
    },
    {
      name: DateCreated,
      selector: (row: (typeof data)[0]) =>
        `${formatDateWithTimeZone(row.created_at)}`,
      sortable: false,
      center: false,
    },

    {
      name: DateModified,
      selector: (row: (typeof data)[0]) =>
        `${formatDateWithTimeZone(row.updated_at)}`,
      sortable: false,
      center: false,
    },
  ];
  const { layoutURL } = useContext(CustomizerContext);
  const newBtn = `${process.env.PUBLIC_URL}/technical/links/create/${layoutURL}`;
  const [loading, setLoading] = useState(true);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<
    (typeof data)[0] | null
  >(null);
  const [editMode, setEditMode] = useState(false);

  const getLinkURL = (data: any, page: number, size = perPage) => {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value)
    );

    const urlParams = {
      organisation_id: String(userOrganisationId),
      page: String(page),
      size: String(size),
      ...filteredData
    };

    const params = new URLSearchParams(urlParams).toString();
  
    return `${LinkApi}?${params}`;
  }

  const fetchData = async (data = {}, page = 1) => {
    setLoading(true);
    setFilterData(data);
    axiosPrivate
      .get(getLinkURL(data, page))
      .then((res) => {
        const response: TechnicalLinkTypes[] = res.data.items;
        setData(response);
        setTotalRows(res.data.total);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          toast.error(err.response.data.detail);
        } else {
          toast.error("Whoops! Something went wrong");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useLayoutEffect(() => {
    fetchData(filterData);
  }, []);

  const getContactId = (result:any) => {
    if (typeof result.contact_id === 'object' && result.contact_id !== null) {
      return result.contact_id.id;
    } else {
      return result.contact_id;
    }
  }

  //
  const handleEditRec = async (
    id: number | string,
    editRecord: (typeof data)[0] | any
  ) => {
    //console.log(getContactId(editRecord));
    editRecord.contact_branch_id = editRecord.contact_branch_id ? editRecord.contact_branch_id : null;
    editRecord.contact_id = getContactId(editRecord);
    editRecord.link_technical_details = {
      location_id: editRecord.location_id,
      link_type_id: editRecord.link_type_id,
      link_status_id: editRecord.link_status_id,
      device_id: editRecord.device_id,
      infrastructure_id: editRecord.infrastructure_id
    };
    
    await axiosPrivate
      .put(`${LinkApi}/${id}`, {
        ...editRecord,
        organisation_id: userOrganisationId,
      })
      .then((_res) => {
        const updatedData = data.map((row) =>
          row.id === selectedRowData!.id ? { ...row, ..._res.data } : row
        );
        setData(updatedData);
        toast.success(`${_res.data.contact.contact_number} Link Editted Successfully.`);
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          toast.error("Validation Errors");
        } else if (err.response && err.response.status === 400) {
          toast.error(err.response.data.detail);
        } else {
          toast.error("Whoops! Something went wrong");
        }
        // throw err;
        toast.error(err.response.message || "Whoops! Something went wrong");
      });
  };

  const handleEdit = (row: (typeof data)[0] | any) => {
    setViewModalOpen(true);
    setEditMode(true);
    row.link_type_id = row.link_technical_detail.link_type_id
    row.link_status_id = row.link_technical_detail.link_status_id
    row.infrastructure_id = row.link_technical_detail.infrastructure_id
    row.location_id = row.link_technical_detail.location_id;
    row.location_type_id = row.link_technical_detail.location.location_type_id;
    row.region_id = row.link_technical_detail.location.region_id;
    row.zone_id = row.link_technical_detail.location.region.zone_id;
    
    row.contact_id = row.contact.id;
    row.contact_branch_id = row.contact_branch?.id;

    row.product_id = row.product?.id;
    row.product_type_id = row.product?.product_type_id;
    row.product_class_id = row.product?.product_type.product_class_id;
    row.product_group_id = row.product?.product_type.product_class.product_group_id;


    LinkTypeDropDown.onChange(row.link_type_id, formFields);
    ZoneOrgDropdownField.onChange(row.zone_id, formFields);
    RegionOrgDropdownField.onChange(row.region_id, formFields);
    LocationTypeDropdownField.onChange(row.location_type_id, formFields);
    
    ProductGroupDropDown.onChange(row.product_group_id, formFields);
    ProductClassDropDown.onChange(row.product_class_id, formFields);
    ProductTypeDropDown.onChange(row.product_type_id, formFields);
    
    customerDropdownField.onSelectedChange(row.contact_id, formFields);
    
    const contactID = formFields.filter(
      (field) => field.name === "contact_id"
    );
    console.log(contactID);
    contactID[0].value.id = row.contact.id;
    contactID[0].value.label = (row.contact.contact_type === ContactTypeVal.Corporate) ?
    `${row.contact.contact_number} ${row.contact.company_name}` :
    ((row.contact.last_name) ?
      `${row.contact.contact_number} ${row.contact.last_name} ${row.contact.first_name}  ${row.contact.middle_name}` :
      "No Name");

    setSelectedRowData(row);
  };
   
  const memoizedHandleEdit = useMemo(
    () => handleEditRec,
    [data, selectedRowData]
  );

  const handleView = (row: (typeof data)[0]) => {
    setViewModalOpen(true);
    setEditMode(false);
    setSelectedRowData(row);
  };

  const handlePageChange = (page: number) => {
    fetchData(filterData, page)
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setLoading(true);
    //const response = await axiosPrivate.get(`${CaseApi}?organisation_id=${userOrganisationId}&page=${page}&size=${newPerPage}`);
    const response = await axiosPrivate.get(getLinkURL(filterData, page, newPerPage));
    setData(response.data.items);
    setPerPage(newPerPage);
    setLoading(false);
  };

  return {
    handleView,
    data,
    tableColumns,
    viewModalOpen,
    selectedRowData,
    editMode,
    newBtn,
    title,
    formFields,
    loading,

    totalRows,
    perPage,
    handlePageChange,
    handlePerRowsChange,
    setViewModalOpen,
    handleEdit,
    memoizedHandleEdit,
    fetchData,
    filterformFields,
    showFilter,
    toggleFilterVisibility,
  };
}
